<template>
  <div class="manage-loan">
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-chip
          class="ma-2"
          color="success"
          outlined
        >
          <v-icon left>
            mdi-account-outline
          </v-icon>
          {{ data.member.fullName }}
        </v-chip>
        <v-chip
          class="ma-2"
          color="success"
          outlined
        >
          <v-icon left>
            mdi-account-outline
          </v-icon>
          کد پرسنلی: {{ data.member.personalCode }}
        </v-chip>
      </v-col>
    </v-row>
    <v-divider class="mb-3" />
    <div>
      <v-tabs v-model="activeTab">
        <v-tab-item :key="0">
          <v-row v-if="!loans || loans.length == 0">
            <v-col cols="12">
              <div class="red--text text-h4 text-center">
                تاکنون وامی برای این عضو ثبت نشده است.
              </div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col
              v-for="l in loans"
              :key="l.id"
              cols="12"
              md="12"
            >
              <v-card
                class=""
                outlined
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="headline mb-1">
                      {{ l.loanModel.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      تاریخ شروع:
                      {{ l.startDate_Persian.date }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      مبلغ وام:
                      {{
                        l.amount.toString().toPriceFormat()
                      }}
                      ریال
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      تعداد اقساط: {{ l.month }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="headline mb-1">
                      بازپرداخت ها
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      تعداد اقساط پرداختی:
                      {{ l.paidCount }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      اقساط پرداخت شده:
                      {{
                        l.paid.toString().toPriceFormat()
                      }}
                      ریال
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      مبلغ باقیمانده:
                      {{
                        l.remain.toString().toPriceFormat()
                      }}
                      ریال
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      تسویه شده:
                      {{ l.isCheckouted ? "بلی" : "خیر" }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="l.isCheckouted">
                      تاریخ تسویه: {{ l.checkoutDate_Persian.date }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-avatar
                    tile
                    rounded="round"
                    size="80"
                    color="grey"
                  />
                </v-list-item>

                <v-card-actions>
                  <v-btn
                    outlined
                    rounded
                    text
                    @click="showInstallments(l)"
                  >
                    مشاهده اقساط
                  </v-btn>
                  <v-btn
                    outlined
                    rounded
                    text
                    @click="payInstallment(l)"
                  >
                    پرداخت قسط
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    class="mx-1"
                    fab
                    dark
                    small
                    color="secondary"
                    title="ویرایش وام"
                    @click="edit(l)"
                  >
                    <v-icon dark>
                      mdi-square-edit-outline
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="pink"
                    title="حذف وام"
                    @click="remove(l)"
                  >
                    <v-icon dark>
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              class="text-center"
            >
              <v-btn
                class="mx-auto"
                color="green"
                dark
                @click="add"
              >
                <v-icon dark>
                  mdi-plus-circle-outline
                </v-icon>
                افزودن وام
              </v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :key="1">
          <loan-installments
            ref="installments"
            :data="{ userloan: selectedUserLoan, adminPanel: true }"
            @back="activeTab = 0"
          />
        </v-tab-item>
      </v-tabs>
    </div>

    <v-dialog
      v-model="dialogModifyUserLoan"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <div><span class="headline">ثبت وام</span></div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <modify-user-loan
              ref="modifyUserLoan"
              :data="selectedUserLoan"
              @callbck="callbck_userLoan"
            />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogModifyLoanPayment"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <div><span class="headline">پرداخت قسط</span></div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <modify-loan-payment
              ref="modifyLoanPayment"
              :data="selectedLoanPayment"
              @callbck="callbck_loanPayment"
            />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <confirm-dlg ref="confirm" />
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import { emptyId } from '@/util/emptyId'
  import toast from '@/util/toast'
  import LoanInstallments from './LoanInstallments.vue'
  import ModifyUserLoan from './ModifyUserLoan.vue'
  import ModifyLoanPayment from './ModifyLoanPayment.vue'

  export default {
    name: 'LoanInstallmentsView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'loan-installments': LoanInstallments,
      'modify-user-loan': ModifyUserLoan,
      'modify-loan-payment': ModifyLoanPayment,
    },
    props: {
      data: { type: Object },
    },
    data () {
      return {
        activeTab: 0,
        errorMessages: '',
        localData: {},
        dialogModifyUserLoan: false,
        dialogModifyLoanPayment: false,
        selectedUserLoan: null,
        selectedLoanPayment: null,
        loans: [],
      }
    },
    mounted () {},
    methods: {
      add () {
        this.dialogModifyUserLoan = true
        this.selectedUserLoan = { id: emptyId, memberModel: this.data.member }
        this.$nextTick(() => {
          this.$refs.modifyUserLoan.prepareData()
        })
      },
      edit (item) {
        this.dialogModifyUserLoan = true
        this.selectedUserLoan = item
        this.$nextTick(() => {
          this.$refs.modifyUserLoan.prepareData()
        })
      },
      async remove (item) {
        if (!item) {
          return
        }

        if (
          await this.$refs.confirm.open(
            'توجه',
            'آیا از حذف این آیتم مطمئن هستید؟',
          )
        ) {
          api
            .post('admin/userloan/delete/' + item.id)
            .then((response) => {
              toast.success('اطلاعات با موفقیت حذف شد.')
              this.loadData()
            })
            .catch((err) => {
              toast.error(err.message)
            })
        }
      },
      loadData () {
        this.activeTab = 0
        api
          .get('admin/userloan/GetLoansByUserId/' + this.data.member.id, null)
          .then((response) => {
            this.loans = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
      showInstallments (userLoan) {
        this.selectedUserLoan = userLoan
        this.activeTab = 1
        setTimeout(() => {
          this.$refs.installments.loadData()
        }, 500)
      },
      payInstallment (userLoan) {
        this.dialogModifyLoanPayment = true
        this.selectedLoanPayment = {
          userLoanModel: userLoan,
          installmentNumber: userLoan.paidCount + 1,
          amount: Math.min(userLoan.remain, userLoan.installment),
        }
        this.$nextTick(() => {
          this.$refs.modifyLoanPayment.prepareData()
        })
      },
      callbck_userLoan (result) {
        this.dialogModifyUserLoan = false
        if (result) {
          this.loadData()
        }
      },
      callbck_loanPayment (result) {
        this.dialogModifyLoanPayment = false
        if (result) {
          this.loadData()
        }
      },
    },
  }
</script>
<style>
.manage-loan .v-tabs .v-tabs-bar {
  display: none;
}
</style>
